import React from "react";
import api from "utils/api";
import "./Others.scss";
import Loader from "Components/Loader";
import TreatmentSummaryChild from "./TreatmentSummaryChild";
import { Empty } from "antd";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultObjects: [],
    };
  }

  componentDidMount() {
    this.getTreatmentAnswerDetails();
  }

  getTreatmentAnswerDetails() {
    this.setState({ isLoading: true });
    api
      .get_treatment_answer_list({
        patient_id: this.props.data?.patient_id,
        type: this.props?.data?.user_type,
      })
      .then((res) => {
        this.setState({
          resultObjects: res.data?.data?.results,
          isLoading: false,
        });
      })
      .catch((err) => {});
  }

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <div className="mhe-wrapper-container">
            <div className="mhe-header">
              <div>Case Formulation 2</div>
            </div>
            <div className="mhe-content"> 
            {this.state.resultObjects.length == 0 ? (
              <Empty
                description={"No Data"}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ) : (
              (this.state.resultObjects || []).map((data, val) => {
                return (
                  <React.Fragment key={val}>
                    {data.is_completed ? (
                      <TreatmentSummaryChild data={data} />
                    ) : null}
                  </React.Fragment>
                );
              })
            )}
            </div>
            
          </div>
        )}
      </>
    );
  }
}
